<template>
<div
  class="modal"
  style="display:block"
>
  <div
    class="modal-dialog"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <div class="row">
          <div class="col-sm-12">
            <span v-if="mode === modalWindowTypes.CREATE">Add new wait</span>
            <span v-if="mode === modalWindowTypes.EDIT">Edit wait</span>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <input
                v-model="models.count"
                class="form-control"
                type="number"
                placeholder="Please input"
              />
            </div>
            <div class="form-group">
              <select
                v-model="models.time"
                class="form-control"
              >
                <option
                  v-for="(variant, idx) of variants"
                  :key="idx"
                >
                  {{ variant }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          v-if="mode === modalWindowTypes.CREATE"
          class="btn btn-success"
          @click="add()"
        >
          Add
        </button>
        <button
          v-if="mode === modalWindowTypes.EDIT"
          class="btn btn-success"
          @click="save()"
        >
          Save
        </button>
        <button
          class="btn btn-danger"
          @click="close()"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  modalWindowTypes
} from '@/utils/dictionaries'

export default {
  name: 'ModalWait',
  props: {
    model: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: modalWindowTypes.CREATE
    }
  },
  data: () => (
    {
      variants: ['minute(s)', 'hour(s)', 'day(s)', 'week(s)', 'month(s)'],
      models: {
        count: 1,
        time: 'day(s)',
        text: ''
      }
    }
  ),
  computed: {
    modalWindowTypes() {
      return modalWindowTypes
    }
  },
  mounted() {
    if (this.model !== null) {
      this.updateData()
    }
  },
  methods: {
    add() {
      this.setText()
      this.$emit('add', { ...this.$data.models })
    },
    save() {
      this.setText()
      this.$emit('save', { ...this.$data.models })
      this.clearData()
    },
    close() {
      this.$emit('close')
    },
    updateData() {
      for (const key in this.models) {
        this.models[key] = this.model.value[key]
      }
    },
    clearData() {},
    setText() {
      this.models.text = `Wait for ${this.models.count} ${this.models.time}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ModalWait.vue